/* import React, { useState } from "react";

function ForcePasswordChangeForm({ username, onPasswordChanged, setSnackbar, theme }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "newPassword") setNewPassword(value);
    if (name === "confirmPassword") setConfirmPassword(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newPassword || !confirmPassword) {
      setSnackbar({
        severity: "error",
        visible: true,
        message: "Completa ambos campos.",
      });
      return;
    }
    if (newPassword !== confirmPassword) {
      setSnackbar({
        severity: "error",
        visible: true,
        message: "Las contraseñas no coinciden.",
      });
      return;
    }
    setLoading(true);
    try {
      // Aquí deberías llamar al servicio de cambio de contraseña
      // await changePasswordService({ username, newPassword });
      setSnackbar({
        severity: "success",
        visible: true,
        message: "Contraseña cambiada correctamente.",
      });
      setLoading(false);
      onPasswordChanged();
    } catch (err) {
      setSnackbar({
        severity: "error",
        visible: true,
        message: "Error al cambiar la contraseña.",
      });
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col h-[28rem] justify-around m-4"
    >
      <div className="space-y-6 pb-5">
        <div>
          <label className="block text-2xl font-medium text-zinc-200 mb-2">
            Usuario
          </label>
          <input
            type="text"
            value={username}
            disabled
            className="w-full text-2xl px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 outline-none"
          />
        </div>
        <div>
          <label className="block text-2xl font-medium text-zinc-200 mb-2">
            Nueva Contraseña
          </label>
          <input
            type="password"
            name="newPassword"
            value={newPassword}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
            required
          />
        </div>
        <div>
          <label className="block text-2xl font-medium text-zinc-200 mb-2">
            Confirmar Nueva Contraseña
          </label>
          <input
            type="password"
            name="confirmPassword"
            value={confirmPassword}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
            required
          />
        </div>
      </div>
      <div className="space-y-4 mb-3">
        <button
          type="submit"
          disabled={loading}
          style={{
            backgroundColor: theme?.colors?.tertiary_dark,
            color: theme?.colors?.text_login_light,
          }}
          className="w-full text-[18px] text-white font-semibold py-3 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Cambiando..." : "Cambiar contraseña"}
        </button>
      </div>
    </form>
  );
}

export default ForcePasswordChangeForm;

 */

import React, { useState } from "react";
import { useConfig } from "../../contexts/config";

const ForgotPasswordForm = ({ onBackToLogin, showForcePasswordChange = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const { config } = useConfig();
  const [error, setError] = useState('');


  const handleForgotPassword = async (event) => {
    event.preventDefault(); // Evita que el formulario recargue la página
    
    if (!email) {
      setError('Por favor, ingresa tu dirección de correo electrónico.');
      return;
    }

    setLoading(true);
    setMessage('');
    setError('');

    // URL de tu endpoint. Asegúrate de que el dominio sea el correcto.
   // const apiUrl = 'https://e-aula.academia-tecnigen.cl/local/forgot_password_tipddy/restore-password.php/user/forgotpassword';
    const apiUrl = 'https://e-aula.academia-tecnigen.cl/tipddy/services/restore-password.php/user/forgotpassword'
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          // Enviamos dinámicamente la URL base de esta aplicación React
          client_url: "https://participante.academia-tecnigen.cl/" // ! window.location.origin,
        }),
      });
      console.log(response)
      const data = await response.json();

      if (response.ok && data.status === 200) {
 setMessage({ 
          type: "success", 
          text: "Hemos enviado un correo con instrucciones para recuperar tu contraseña" 
        });
        setEmail(''); // Limpiar el campo de email
      } else {
        // Usar el mensaje del backend si está disponible, o uno genérico
         setMessage({ 
          type: "error", 
          text: data.message || "No pudimos procesar tu solicitud. Verifica tu correo e intenta nuevamente." 
        });
      }
    } catch (err) {
      setMessage({ 
        type: "error", 
        text: "Ocurrió un error al procesar tu solicitud. Por favor intenta más tarde." 
      });
      console.error('Error en la solicitud de recuperación:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-5">
      {/* Header */}
      <div className="mb-4">
        <h2 className="text-lg font-bold mb-1" style={{ color: "#e2e1f4" }}>
          {showForcePasswordChange ? "Cambia tu contraseña" : "Recupera tu contraseña"}
        </h2>
        <p className="text-sm leading-relaxed" style={{ color: "#d3c4ae" }}>
          {showForcePasswordChange
            ? "Por seguridad, ingresa tu correo electrónico y te enviaremos instrucciones para definir tu nueva contraseña."
            : "Ingresa tu correo electrónico y te enviaremos instrucciones para restablecer tu contraseña."}
        </p>
      </div>

      {/* Form */}
      <form onSubmit={handleForgotPassword} className="space-y-4">
        <div className="space-y-2">
          <label
            htmlFor="email"
            className="block text-sm font-semibold tracking-wide"
            style={{ color: "#e2e1f4" }}
          >
            Correo electrónico
          </label>
          <div className="relative">
            <span
              className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-[20px] pointer-events-none"
              style={{ color: "#d3c4ae" }}
            >
              mail
            </span>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ejemplo@correo.com"
              className="w-full py-3 pl-10 pr-4 rounded-lg border border-white/10 outline-none transition-all text-sm"
              style={{ backgroundColor: "#0c0d1a", color: "#e2e1f4" }}
              onFocus={(e) => {
                e.target.style.borderColor = "#91d0df";
                e.target.style.boxShadow = "0 0 0 2px rgba(145, 208, 223, 0.2)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "rgba(255,255,255,0.1)";
                e.target.style.boxShadow = "none";
              }}
              required
            />
          </div>
        </div>

        {/* Message display */}
        {message.text && (
          <div
            className={`p-3 rounded-lg text-sm ${
              message.type === "success"
                ? "bg-green-600/20 text-green-200"
                : "bg-red-600/20 text-red-200"
            }`}
          >
            {message.text}
          </div>
        )}

        {/* Submit */}
        <button
          type="submit"
          disabled={loading}
          className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-lg font-semibold text-sm transition-all active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ backgroundColor: "#ecb236", color: "#634600" }}
          onMouseEnter={(e) => { if (!loading) e.currentTarget.style.opacity = "0.9"; }}
          onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; }}
        >
          {loading ? (
            <>
              <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
              Procesando...
            </>
          ) : (
            "Enviar instrucciones"
          )}
        </button>

        {/* Back */}
        <button
          type="button"
          onClick={onBackToLogin}
          className="w-full py-2 px-4 rounded-lg text-sm font-medium border transition-all"
          style={{ borderColor: "#91d0df", color: "#91d0df" }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(145, 208, 223, 0.08)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
        >
          Volver al inicio de sesión
        </button>
      </form>
    </div>
  );
};

export default ForgotPasswordForm;